import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/map";
import { Role } from "../../interface/role";

@Injectable()
export class RoleService {
  roleAction = new Subject();
  constructor(private httpClient: HttpClient) {}

  create(body): Observable<any> {
    return this.httpClient.post("role", body);
  }

  update(body): Observable<any> {
    return this.httpClient.patch("role", body);
  }

  list(data: string = ""): Observable<Role> {
    if (data) {
      data = "?" + data;
    }
    return this.httpClient.get<Role>("role" + data);
  }

  delete(id): Observable<any> {
    return this.httpClient.delete("role/" + id);
  }

  getAction(): Observable<any> {
    return this.roleAction.asObservable();
  }

  sendAction(action, data) {
    this.roleAction.next({ action: action, data: data });
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/role/role.service.ts